import { Grid } from "@mui/material";
import React from "react";
import SmsHeader from "./home/header";
import SmsTable from "./home/table";

const Sms = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SmsHeader />
      </Grid>
      <Grid item xs={12}>
        <SmsTable />
      </Grid>
    </Grid>
  );
};

export default Sms;
